/**
 * @description: 主页面
 * @author: fire
 * @update: hwx
 */
<template>
    <div id="app">
        <v-header ref="vheader"></v-header>
        <router-view ref="index_content"></router-view>
    </div>
</template>

<script>
import header from '@/components/header.vue';

export default {
    name: 'app',
    data() {
        return {};
    },
    components: {
        'v-header': header
    },
    computed: {
        menunew() {
            let menu = []
            // 首次登陆等待获取 menunew
            if(this.$store.state.menunew.length > 0) {
                menu = JSON.parse(this.$store.state.menunew)
            }
            return menu
        },
    },
    created: function() {
        this.$nextTick(() => {
            this.selectMenu();
        });
        this.$root.$on('firstMenuClick', selectedMenu => {
            this.secondMenu(selectedMenu);
        });
    },
    mounted: function() {},
    methods: {
        selectMenu() {
            let path = this.$router.currentRoute.path;
            if(path != "/") {
                let aPath = path.split("/");
                for(let i = 0; i < this.menunew.length; i++) {
                    if(this.menunew[i].url == aPath[1]) {
                        this.$refs.vheader.$children[1].$emit("firstMenu", this.menunew[i]);
                        break;
                    }
                }
            }
        },
        secondMenu(selectedMenu) {
            let index_content = this.$refs.index_content;
            if(typeof index_content != "undefined") {
                if(typeof index_content.secondMenu == "function") {
                    // 三级菜单逐步开放
                    if(selectedMenu.id == '544') {
                        index_content.thirdMenu(selectedMenu, selectedMenu.submenu[0], selectedMenu.submenu[0].submenu[0]);
                    } else {
                        index_content.secondMenu(selectedMenu, selectedMenu.submenu[0]);
                    }
                }
            }
        }
    }
}
</script>

<style lang="less">
    @import "./assets/css/common";
    html, body {
        overflow: hidden;
        height: 100%;
    }
    body {
        min-width: 970px;
        background: #f5f5f5;
    }
    #app {
        height: 100%;
        padding: 72px 0 0;
        font-size: 14px;
        font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
        /* 抗锯齿 */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
